import { MessageDescriptor, useIntl } from "react-intl";
import BooleanFilter from "./base/BooleanFilter";
import { FilterViewProps } from "./base/types";

function SimpleBooleanFilter(
  trueMsg: MessageDescriptor,
  falseMsg: MessageDescriptor,
  hide?: never
): React.ComponentType<FilterViewProps>;

function SimpleBooleanFilter(
  trueMsg: MessageDescriptor | null,
  falseMsg: MessageDescriptor,
  hide: "hideTrue"
): React.ComponentType<FilterViewProps>;

function SimpleBooleanFilter(
  trueMsg: MessageDescriptor,
  falseMsg: MessageDescriptor | null,
  hide: "hideFalse"
): React.ComponentType<FilterViewProps>;

function SimpleBooleanFilter(
  trueMsg: MessageDescriptor | null,
  falseMsg: MessageDescriptor | null,
  hide?: "hideTrue" | "hideFalse"
) {
  const Filter = (props: FilterViewProps) => {
    const { formatMessage } = useIntl();
    return (
      <BooleanFilter
        {...props}
        labels={[trueMsg ? formatMessage(trueMsg) : "", falseMsg ? formatMessage(falseMsg) : ""]}
        hideTrue={hide === "hideTrue"}
        hideFalse={hide === "hideFalse"}
      />
    );
  };
  return Filter;
}

export default SimpleBooleanFilter;
